import { promotions } from "./promotions"

// linked: '@:global.terms 使用內部連結範例 @:global.policy'
// hello: '{msg} world'  => {{ $t('message.hello', { msg: 'hello' })
// hello: '{0} world' => {{ $t('message.hello', ['hello']) }}
// car: 'car | cars' => {{ $tc('car', 1) }}, {{ $tc('car', 2) }}

export default {
  global: {
    next: "下一步",
    prev: "上一步",
    selectAll: "全選",
    action: "動作",
    view: "查看",
    day: "天",
    hour: "時",
    hourFull: "小時",
    minute: "分",
    second: "秒",
    quickView: "快速查看",
    viewAll: "查看全部",
    ok: "確定",
    cancel: "取消",
    close: "關閉",
    submit: "送出",
    setting: "設定",
    default: "預設",
    choose: "選擇",
    type: "類型",
    areYouSure: "確定執行?",
    confirmDelete: "確定刪除",
    confirmCancel: "確定取消",
    empty: "查無資料",
    update: "更新",
    sortBy: "排序方式",
    use: "使用",
    remove: "移除",
    delete: "刪除",
    contactUs: "聯絡客服",
    allTotal: "共",
  },
  paging: {
    prevPage: "上一頁",
    nextPage: "下一頁",
    totalCount: "共 {0} 筆",
  },
  errors: {
    serverErr: "系統發生異常, 請稍後再試!",
    inputError: "請檢查資料是否填寫完整",
    requiredLogin: "請先登入會員",
    submitOrderError: "建立訂單失敗! 系統繁忙或網路異常，請重試",
    pleaseInput: "請輸入 {0}",
    pleaseSelect: "請選擇 {0}",
    pleaseUpload: "請上傳 {0}",
    formatError: "{0} 格式錯誤",
    digits: "請輸入整數",
  },
  carts: {
    continueShopping: "去逛逛",
    continueShopping2: "繼續逛逛",
    checkout: "前往結帳",
    subTotal: "小計",
    empty1: "購物車還沒有東西!",
    empty2: "快點加入商品吧!",
    totalItemAndTotal: "({0} 項商品) 折扣後總金額",
    buyerInfo: "填寫訂購人資訊",
    required: "必填",
    optional: "選填",
    currentlySelected: "您目前共選了",
    items: "{0}件商品",
    goToEvent: "前往活動",
    modelInvalid: "型號失效",
    ProductOff: "商品下架",
    ProductRemaining: "剩下 {0} 個商品",
    shippingMethod: "配送方式",
    invalidItem: "商品【{0}】已失效，請取消勾選",
    removedItem: "商品【{0}】已下架，請取消勾選",
    inventoryItem: "商品【{0}】庫存不足，請取消勾選",
    abnormalItem: "商品【{0}】資料異常，請取消勾選",
    sameAsBuyer: "與宅配地址相同",
    shoppingCart: "購物車",
    gift: "贈品",
    addOn: "加購品",
    differentBuyer: "收件人與訂購人不同",
    addToCart: "加入購物車",
    soldOut: "已售完",
    buyNow: "直接買",
    giveAwayDone: "贈送完畢",
    useDiscountCode: "使用折扣碼",
    emptyDiscountCode: "無可用折扣碼",
    unitPrice: "單價",
    commPrice: "原價",
    options: "規格選項",
    confirmChangeAssort: "確認更改規格選項",
    groupDetail: "訂單內容",
    editing: "編輯",
  },
  orders: {
    title: "我的訂單",
    cycleOrders: "循環購訂單",
    memo: "備註",
    assortDiscount: "商品折扣",
    promDiscount: "活動折扣",
    enable_coin_discount: "紅利折抵",
    insuranceFees: "售後保障",
    deliveryFeesDiscount: "運費折扣",
    deliveryFees: "運費",
    productDetails: "商品",
    qty: "數量",
    price: "金額",
    subtotal: "商品總額",
    total: "總計",
    buyerName: "訂購人姓名",
    buyerPhone: "訂購人手機",
    toName: "收件人姓名",
    toPhone: "收件人手機",
    toAddress: "收件人地址",
    mart: "門市",
    paymentMethod: "付款方式",
    paymentAt: "付款時間",
    shippingMethod: "配送方式",
    shippingAt: "出貨時間",
    addressHint: "※ 實際運費會依配送地區重新計價。",
    recipientInfo: "填寫收件人資訊",
    shippingAddress: "宅配地址",
    shop711: "7-11門市",
    shopFami: "全家門市",
    shopHilife: "萊爾富門市",
    shopOkmart: "OK門市",
    discount: "折扣金額",
    otherFees: "其他手續費",
    paymentFees: "金流手續費",
    id: "訂單編號",
    createAt: "訂單日期",
    orderNo: "訂單編號",
    createDate: "訂單日期",
    status: "訂單狀態",
    orderTotal: "訂單金額",
    empty: "沒有訂單資料",
    mStatus: {
      pending_payment: "待付款",
      processing: "進行中",
      already_delivery: "已出貨",
      pending_refund: "待退款",
      done: "已完成",
      abnormal_done: "異常結束",
      expired: "已到期",
      active: "啟用中",
    },
    trackingNo: "託運單號",
    shippingLogs: "出貨紀錄",
    shippingDetails: "出貨內容",
    refundDetails: "退款內容",
    refundMethod: "退款方式",
    refundAccount: "退款帳戶",
    refundQty: "退款數量",
    refundAmount: "退款金額",
    refundStatus: {
      pending: "等待退款",
      processing: "退款申請中",
      done: "退款完成",
      canceled: "已取消",
    },
    cancelOrder: "取消此筆訂單",
    CancellationByCustomer: "客戶自行取消",
    canceled: "訂單已取消",
    parentId: "母單編號",
    subscriptionDate: "訂閱日期",
    periodCountLimit: "總期數",
    periodCount: "期數",
    showInfo: "顯示詳情",
    hideInfo: "隱藏詳情",
    notYetGenerated: "尚未產生",
  },
  invoices: {
    title: "發票資料",
    type: "發票類型",
    personal: "二聯式紙本發票",
    company: "三聯式紙本發票",
    donation: "捐贈發票",
    eturnkey: "電子發票",
    member: "會員載具",
    mobile: "手機載具",
    mobileCode: "手機載具條碼",
    moica: "自然人憑證",
    moicaCode: "自然人憑證條碼",
    requestPaper: "索取紙本",
    uniformNumbers: "統一編號",
    companyName: "企業抬頭",
    carrierCode: "載具條碼",
    address: "發票寄送地址",
  },
  products: {
    temperature0: "常溫",
    temperature1: "冷藏",
    temperature2: "冷凍",
    priceLowToHigh: "價格低到高",
    priceHighToLow: "價格高到低",
    empty: "沒有更多商品了",
    salePrice: "售價",
    addonPrice: "加購價",
    daigouPrice: "代購價",
    wholesalePrice: "批發價",
    purchasePrice: "採購價",
    assorts: "商品組合",
  },
  saas: {
    empty: "沒有更多應用了",
  },
  promotions,
  coins: {
    title: "紅利折抵",
    yourCoins: "紅利餘額",
    maxCoins: "最高可使用 {0}",
    useCoin: "本次使用",
    useAllCoin: "全部抵用",
    useHint: "紅利折抵最高至商品 0 元為止，無法折抵運費使用",
    record: "紅利紀錄",
    earnedCoins: "獲得紀錄",
    awaitingCoins: "即將獲得",
    usedCoins: "使用紀錄",
    subscriptionCoins: "訂閱紅利",
    subscriptionOfflineCoins: "下線訂閱紅利",
    orderCoins: "訂單紅利",
    orderOfflineCoins: "下線訂單紅利",
    kolCoins: "網紅訂單紅利",
    bonus: "紅利",
    subscriber: "訂閱人",
    buyer: "購買人",
    detail: "佣金詳情",
    currentSales: "目前銷售業績",
    nextTotal: "到下一個等級還差",
    availableSales: "可銷量",
    memberOnly: "會員限購",
    level: "等級",
    yourLevel: "您的等級",
    upgradeConditions: "升級條件",
    turnover: "營業額",
    pv: "佣金",
  },
  users: {
    title: "會員資料",
    name: "姓名",
    email: "信箱",
    phone: "手機",
    toAddress: "通訊地址",
    province: "縣市",
    city: "行政區域",
    region: "鄉鎮里鄰",
    road: "道路",
    address: "詳細地址",
    postcode: "郵遞區號",
    realName: "真實姓名",
    identityNo: "身份證字號",
    birthday: "生日",
    buyerAddress: "戶籍地址",
    buyerAddressHelper: "(需與身份證同)",
    buyerAddressDesc: "需包含鄰里資訊",
    tel: "聯絡電話",
    updateSuccess: "會員資料已更新",
  },
  accounts: {
    userInfo: "用戶資訊",
    createBankAccount: "銀行帳號",
    confirmInfo: "確認內容",
    identitySuccess: "帳號設定完成",
    decryptData: "個資解密",
    bankInfoAlert: "銀行帳號資訊需與身份證字號一致, 否則可能會影響日後撥款權益",
    address: "常用地址",
    addAddress: "加入常用地址",
    selectAddress: "選擇常用地址",
    createAddress: "新增常用地址",
    editAddress: "編輯常用地址",
    deleteAddress: "刪除此筆常用地址",
    updateAddressSuccess: "常用地址已更新",
    createAddressSuccess: "常用地址已新增",
    removeAddressSuccess: "常用地址已刪除",
    createRefundAccount: "新增退款帳戶",
  },
  bankInfo: {
    atmTitle: "銀行虛擬 ATM 帳戶",
    atmAccountName: "帳戶名稱",
    atmAccountNo: "虛擬帳號",
    accountName: "銀行戶名",
    accountNo: "銀行帳號",
    bank: "銀行名稱",
    branch: "分行名稱",
    accountImg: "存摺圖檔",
    accountImgTip: "銀行存摺正面圖片",
    amount: "應付金額",
    expireDate: "有效期限",
  },
  subscriptions: {
    startAt: "訂閱時間",
    paidAt: "付款時間",
    notPaidYet: "尚未付款",
    goToPayment: "前往付款",
    changePaymentMethod: "變更付款方式",
    changePaymentMethodSuccess: "訂單付款方式已變更",
    paid: "付費訂閱",
    giftRecord: "贈送紀錄",
    record: "訂閱紀錄",
  },
  invoices: {
    title: "發票",
    type: "發票類型",
    personal: "二聯式紙本發票",
    company: "三聯式紙本發票",
    donation: "捐贈發票",
    eturnkey: "不需捐贈 / 公司統編",
    member: "會員載具",
    mobile: "手機載具",
    mobileCode: "手機載具條碼",
    moica: "自然人憑證",
    moicaCode: "自然人憑證條碼",
    requestPaper: "索取紙本",
    uniformNumbers: "統一編號",
    companyName: "企業抬頭",
    companyNumber: "公司統編",
    carrierCode: "載具條碼",
    address: "發票寄送地址",
    electronicPersonal: "個人雲端發票",
    electronicCorporation: "公司電子發票",
    paperPersonal: '個人電子發票',
    paperCorporation: "公司用(郵寄)",
    corporation: "公司用",
    donateXCA: "捐贈單位",
  },
  shopCoins: {
    title: "「購物金」折抵",
    yourCoins: "購物金",
    maxCoins: "最高可使用 {0}",
    useCoin: "本次使用",
    useAllCoin: "全部抵用",
    useHint: "購物金折抵最高至「總金額 0 元」為止",
    record: "購物金紀錄",
    earnedCoins: "獲得紀錄",
    awaitingCoins: "即將獲得",
    usedCoins: "使用紀錄",
    subscriptionCoins: "訂閱購物金",
    subscriptionOfflineCoins: "加盟店訂閱購物金",
    orderCoins: "訂單",
    orderOfflineCoins: "加盟店訂單購物金",
    kolCoins: "網紅訂單購物金",
    bonus: "購物金",
    subscriber: "訂閱人",
    buyer: "購買人",
  },
  "新增取貨門市": "新增取貨門市",
  "從最近門市挑選": "從最近門市挑選",
  "重新挑選": "重新挑選",
  "總金額": "總金額",
  "門市": "門市",
  "費用": "費用",
  "查看價格明細": "查看價格明細",
  "最近門市": "最近門市",
  "範例格式": "範例格式",
  "收件人姓名": "收件人姓名",
  "收件人手機": "收件人手機",
  "您已達到免運條件！": "您已達到免運條件！",
  "免運": "免運",
  "運費": "運費",
  "線上列印": "線上列印",
  "商品小計": "商品小計",
  "請檢查您輸入的E-mail格式是否正確": "請檢查您輸入的E-mail格式是否正確",
}
